import type { MetricId } from "./metricDetailsTypes"

// Display name per metric — the single source shared by the panel title
// (METRIC_DETAILS) and the trigger aria-labels (useMetricTrigger). Kept in its
// own tiny module so triggers don't pull in the whole metricDetailsData prose.
export const METRIC_LABELS: Record<MetricId, string> = {
  labor: "Machine Labor",
  income: "Median Income",
  employment: "Employment Rate",
  safetyTax: "Total Slowdown",
  alignment: "Safety Researchers",
  capability: "AI Capabilities",
  power: "Distribution of Power",
}

// Appended to a wired metric's HUD tooltip to advertise the click affordance.
export const METRIC_DETAILS_HINT = "Click to see details"
